import React from 'react'
import { useTranslation } from 'react-i18next'

import "./waves.scss"
export default function Waves() {
    const {t} = useTranslation(["common"]);

  return (
    <div className='wavesdiv'>
        <div>
            <svg className="wavessvg" xmlns="http://www.w3.org/2000/svg" xmlnsxxlink="http://www.w3.org/1999/xlink"
            viewBox="0 24 150 28" preserveAspectRatio="none" shapeRendering="auto">
                <defs>
                    <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
                </defs>
                <g className="parallax">
                    <use xlinkHref="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.7" />
                    <use xlinkHref="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.5)" />
                    <use xlinkHref="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.3)" />
                    <use xlinkHref="#gentle-wave" x="48" y="7" fill="#fff" />
                </g>
            </svg>
        </div>

        <div className="content flex">
            
        <p>{t("Develop")} <a href="https://twitter.com/Nacho_gorriti_" target="_blank" rel="noreferrer">
                     Ignacio Gorriti</a> | <a className="acserp" href='https://www.instagram.com/modeloonulp/'target="_blank" rel="noreferrer">Asociacion Civil de Simulacros educativos del Rio de La Plata</a></p>
        </div>
    </div>
  )
}
